import { ImportMappingDto } from "../../../../domain/DataKitDto";

export const MAPPING_TARGETS = [
  { value: "IGNORE", label: "Don't import" },
  { value: "NAME", label: "Item name" },
  { value: "GROUP", label: "Group" },
  { value: "SUBGROUP", label: "Subgroup" },
  { value: "DESCRIPTION", label: "Description" },
  { value: "SIZE", label: "Size label" },
  { value: "PRICE", label: "Price" },
  { value: "TAGS", label: "Tags" },
  { value: "DIETARY", label: "Dietary flag column" },
  { value: "EXTERNAL_ID", label: "External ID" },
];

const EXACTLY_ONCE = ["GROUP", "NAME"];
const AT_MOST_ONCE = ["SUBGROUP", "DESCRIPTION", "TAGS", "EXTERNAL_ID"];
const PAIRED = ["SIZE", "PRICE"];

const labelFor = (target: string) =>
  MAPPING_TARGETS.find((t) => t.value === target)?.label || target;

export function needsPairIndex(target: string): boolean {
  return PAIRED.includes(target);
}

export function validateMapping(mapping: ImportMappingDto[]): string[] {
  const errors: string[] = [];
  const countOf = (target: string) => mapping.filter((m) => m.target === target).length;

  EXACTLY_ONCE.forEach((target) => {
    const count = countOf(target);
    if (count === 0) errors.push(`Map one column to ${labelFor(target)}.`);
    if (count > 1) errors.push(`Only one column can be ${labelFor(target)}.`);
  });

  AT_MOST_ONCE.forEach((target) => {
    if (countOf(target) > 1) errors.push(`Only one column can be ${labelFor(target)}.`);
  });

  PAIRED.forEach((target) => {
    const seen = new Set<number>();
    mapping
      .filter((m) => m.target === target)
      .forEach((m) => {
        const pair = m.pairIndex ?? 0;
        if (seen.has(pair)) {
          errors.push(`Two columns are ${labelFor(target)} for price ${pair + 1}.`);
        }
        seen.add(pair);
      });
  });

  const pricePairs = new Set(
    mapping.filter((m) => m.target === "PRICE").map((m) => m.pairIndex ?? 0)
  );
  mapping
    .filter((m) => m.target === "SIZE")
    .forEach((m) => {
      const pair = m.pairIndex ?? 0;
      if (!pricePairs.has(pair)) {
        errors.push(`Size label for price ${pair + 1} has no matching price column.`);
      }
    });

  return Array.from(new Set(errors));
}
